import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Icon } from './Icon.js';
export function Button({ variant = 'primary', size = 'md', icon, iconRight, loading, disabled, className, children, type = 'button', ...rest }) {
    const cls = clsx('sterling-btn', `sterling-btn-${variant}`, `sterling-btn-${size}`, className);
    const iconSize = size === 'sm' ? 14 : 16;
    return (_jsxs("button", { type: type, className: cls, disabled: disabled || loading, ...rest, children: [loading
                ? _jsx(Icon, { name: "loader", size: iconSize, className: "sterling-spin" })
                : icon && _jsx(Icon, { name: icon, size: iconSize }), children != null && _jsx("span", { children: children }), iconRight && !loading && _jsx(Icon, { name: iconRight, size: iconSize })] }));
}
export function IconButton({ icon, label, size = 'md', className, ...rest }) {
    const cls = clsx('sterling-iconbtn', size === 'sm' && 'sm', className);
    const iconSize = size === 'sm' ? 14 : 18;
    return (_jsx("button", { className: cls, "aria-label": label, title: label, ...rest, children: _jsx(Icon, { name: icon, size: iconSize }) }));
}
//# sourceMappingURL=Button.js.map